export default __webpack_public_path__ + "static/media/img-top-3.ae6f992a.jpg";